/* oxlint-disable max-lines */
import { mergeChats } from './helpers';
import { EArchivedListActionTypes } from '../../actions/archivedList';
import { EChatListActionTypes } from '../../actions/chatList';
import { ESpamListActionTypes } from '../../actions/spamList';
import { EStarredChatsListActionTypes } from '../../actions/starredChatsList';
import { EUnreadListActionTypes } from '../../actions/unreadList';
import { mapChat } from '../../mappers';
import { ERequestApiStatus, TAppState } from '../../types/appState';
import { EMasterTabs } from '../../types/masterFilters';
import { TReduxActions } from '../../types/redux/actions';
import { ERoute } from '../../types/route';

export function chatListReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EChatListActionTypes.SetLoadPageSucceed:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          isLoadProgress: false,
        },
      };
    // FIXME разнести на разные экшены
    case EChatListActionTypes.SetPending:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          notClearCurrentOpenedChatId: action.payload.notClearCurrentOpenedChatId,
          status: ERequestApiStatus.Pending,
          timestamp: action.payload.timestamp,
          isLoadProgress: true,
        },
      };

    case EChatListActionTypes.TogglePending:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          // FIXME статус списка по факту булевое значение, не нужно отличать неуспешное от успешного
          status: action.payload ? ERequestApiStatus.Pending : ERequestApiStatus.Succeed,
        },
      };

    // FIXME: Избавиться от экшена
    case ESpamListActionTypes.SetPending:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          status: ERequestApiStatus.Pending,
          timestampSpam: action.payload.timestampSpam,
          isLoadProgress: true,
        },
      };

    // FIXME: Избавиться от экшена
    case EArchivedListActionTypes.SetPending:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          status: ERequestApiStatus.Pending,
          timestampArchive: action.payload.timestampArchive,
          isLoadProgress: true,
        },
      };

    // FIXME: Избавиться от экшена
    case EUnreadListActionTypes.SetPending:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          status: ERequestApiStatus.Pending,
          timestampArchive: action.payload.timestamp,
          isLoadProgress: true,
        },
      };

    // FIXME: Избавиться от экшена
    case EStarredChatsListActionTypes.SetPending:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          status: ERequestApiStatus.Pending,
          timestampStarred: action.payload.timestampStarred,
          isLoadProgress: true,
        },
      };

    case EChatListActionTypes.SetSucceed: {
      const chats = state.chatList.chats.filter(({ status }) => status !== 'blocked' && status !== 'archived');

      // TODO: понять что тут происходит и отрефакторить
      const movedToArchiveChatIds = state.chatList.movedToArchiveChatIds.filter(movedChatId => {
        return chats.find(chat => chat.chatId !== movedChatId);
      });

      // TODO: понять что тут происходит и отрефакторить
      const movedToSpamChatIds = state.chatList.movedToSpamChatIds.filter(movedChatId => {
        return chats.find(chat => chat.chatId !== movedChatId);
      });

      return {
        ...state,
        chatList: {
          ...state.chatList,
          chats: mergeChats(chats, action.payload),
          allChatsLoaded: action.payload.length === 0,
          status: ERequestApiStatus.Succeed,
          isFirstLoad: false,
          movedToArchiveChatIds: chats.length > 0 ? movedToArchiveChatIds : state.chatList.movedToArchiveChatIds,
          movedToSpamChatIds: chats.length > 0 ? movedToSpamChatIds : state.chatList.movedToSpamChatIds,
        },
      };
    }

    case EChatListActionTypes.SetFullSucceed:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          chats: action.payload,
          allChatsLoaded: action.payload.length === 0,
          status: ERequestApiStatus.Succeed,
        },
      };

    case ESpamListActionTypes.SetSucceed: {
      const chats = state.chatList.chats.filter(({ status }) => status === 'blocked');

      return {
        ...state,
        chatList: {
          ...state.chatList,
          chats: mergeChats(chats, action.payload),
          allChatsLoaded: action.payload.length === 0,
          status: ERequestApiStatus.Succeed,
          isFirstLoad: false,
        },
      };
    }

    case EArchivedListActionTypes.SetSucceed: {
      const chats = state.chatList.chats.filter(({ status }) => status === 'archived');

      return {
        ...state,
        chatList: {
          ...state.chatList,
          chats: mergeChats(chats, action.payload),
          allChatsLoaded: action.payload.length === 0,
          status: ERequestApiStatus.Succeed,
          isFirstLoad: false,
        },
      };
    }

    case EUnreadListActionTypes.SetSucceed: {
      const chats = state.chatList.chats.filter(chat => chat.unreadMessagesCount > 0);

      return {
        ...state,
        chatList: {
          ...state.chatList,
          chats: mergeChats(chats, action.payload),
          allChatsLoaded: action.payload.length === 0,
          status: ERequestApiStatus.Succeed,
          isFirstLoad: false,
        },
      };
    }

    case EStarredChatsListActionTypes.SetSucceed: {
      const chats = state.chatList.chats.filter(chat => chat.isStarred);

      return {
        ...state,
        chatList: {
          ...state.chatList,
          chats: mergeChats(chats, action.payload),
          allChatsLoaded: action.payload.length === 0,
          status: ERequestApiStatus.Succeed,
          isFirstLoad: false,
        },
      };
    }

    case EChatListActionTypes.SetFailed:
    case EArchivedListActionTypes.SetFailed:
    case ESpamListActionTypes.SetFailed:
    case EUnreadListActionTypes.SetFailed:
    case EStarredChatsListActionTypes.SetFailed:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          status: ERequestApiStatus.Failed,
          isFirstLoad: false,
          isLoadProgress: false,
        },
      };

    case EChatListActionTypes.UpdatedFromServer: {
      const incomingChat = mapChat(action.payload);

      // TODO: понять что тут происходит и отрефакторить
      const movedToArchiveChatIds = state.chatList.movedToArchiveChatIds.filter(movedChatId => {
        return movedChatId !== incomingChat.chatId;
      });

      // После добавления custom actions нужно дополнительно проверять, что изменился статус чата (заблокирован/удален/заархивирован)
      const currentChat = state.chatList.chats.find(chat => chat.chatId === incomingChat.chatId);
      const wasChangedChatStatus =
        currentChat && (currentChat.status !== incomingChat.status || incomingChat.status === 'deleted');

      // Если изменения в чате сотрудника, не обнуляем счетчик непрочитанных сообщений
      if (state.masterFilters.activeTab === EMasterTabs.SubAgentsChats && state.masterFilters.selectedSubAgentId) {
        incomingChat.unreadMessagesCount = currentChat?.unreadMessagesCount || incomingChat.unreadMessagesCount;
      }

      /*
        Удалить чат из списка, если:
        - текущая секция - архив, и чат не архивирован
        - текущая секция - заблокированные, и чат не заблокирован
        - для любой другой секции чат удален/архивирован
       */
      if (
        (state.chatList.currentRoute === ERoute.Archive && incomingChat.status !== 'archived') ||
        (state.chatList.currentRoute === ERoute.Spam && incomingChat.status !== 'blocked') ||
        (wasChangedChatStatus && (incomingChat.status === 'deleted' || incomingChat.status === 'archived'))
      ) {
        return {
          ...state,
          chatList: {
            ...state.chatList,
            chats: state.chatList.chats.filter(chat => {
              return chat.chatId !== incomingChat.chatId;
            }),
            movedToArchiveChatIds,
          },
        };
      }

      // в остальных случаях чат либо перешел в новое состояние, либо просто новый
      return {
        ...state,
        chatList: {
          ...state.chatList,
          chats: mergeChats(state.chatList.chats, [incomingChat]),
          movedToArchiveChatIds,
        },
      };
    }

    case EChatListActionTypes.SetInitial:
      return {
        ...state,
        chatList: {
          chats: [],
          currentRoute: ERoute.Messages,
          status: ERequestApiStatus.Succeed,
          isFirstLoad: true,
          allChatsLoaded: false,
          isChangeListActive: false,
          movedToArchiveChatIds: [],
          movedToSpamChatIds: [],
          selectedChats: [],
          timestamp: undefined,
          timestampSpam: undefined,
          timestampArchive: undefined,
          removedFromSpamChatId: undefined,
          removedFromArchiveChatId: undefined,
          notClearCurrentOpenedChatId: undefined,
          isLoadProgress: false,
        },
      };

    case EChatListActionTypes.ToggleChangeListActive:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          isChangeListActive: !state.chatList.isChangeListActive,
          selectedChats: [],
        },
      };

    case EChatListActionTypes.AddChatToSelected:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          selectedChats: state.chatList.selectedChats.concat(action.payload),
        },
      };

    case EChatListActionTypes.RemoveChatFromSelected:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          selectedChats: state.chatList.selectedChats.filter(chatId => chatId !== action.payload),
        },
      };

    case EChatListActionTypes.SelectAllChats:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          selectedChats: state.chatList.chats.map(({ chatId }) => chatId),
        },
      };

    case EChatListActionTypes.DeselectAllChats:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          selectedChats: [],
        },
      };

    case EChatListActionTypes.SetSyncPending:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          status: ERequestApiStatus.Pending,
        },
      };

    case EChatListActionTypes.SetSyncSucceed:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          chats: mergeChats(state.chatList.chats, action.payload),
          status: ERequestApiStatus.Succeed,
        },
      };

    // при синхронизации чатов не указываем ошибку
    case EChatListActionTypes.SetSyncFailed:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          status: ERequestApiStatus.Succeed,
        },
      };

    default:
      return state;
  }
}
